export default {"src":"/_next/static/media/moderateRain.bfaf7132.svg","height":161,"width":161};